































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { hasFootPrmission } from '@/common/ts/common';
import XcqImage from './XcqImage.vue';

@Component({
  components: {
    XcqImage,
  },
})
export default class XcqManuscriptFooter extends Vue {
  @Prop({
    default: () => ({
      label: '',
      pv: '',
      publishTime: '',
      mediaAccountName: '',
    }),
  })
  dataInfo!: any;

  private themeConfig: any = null;

  created() {}

  // 计算属性 - 移除所有可选链操作符
  get newsItemLogo(): any {
    return (this.themeConfig && this.themeConfig.newsItemLogo) || {};
  }

  get hasNewsItemLogoIcon(): boolean {
    return !!(this.newsItemLogo && this.newsItemLogo.icon);
  }

  get canShowLabel(): boolean {
    return (
      !!(this.dataInfo && this.dataInfo.label) &&
      hasFootPrmission(
        0,
        (this.dataInfo && this.dataInfo.showPermission) || 0,
      ) &&
      this.dataInfo.label !== '无'
    );
  }

  get matchedNewsItemLogo(): any {
    const conditionLabel =
      this.newsItemLogo && this.newsItemLogo.conditionLabel;
    if (!Array.isArray(conditionLabel)) {
      return null;
    }
    return (
      conditionLabel.find(
        (item) => item && item.label === this.dataInfo && this.dataInfo.label,
      ) || null
    );
  }

  get customLabelText(): string {
    return (
      (this.matchedNewsItemLogo && this.matchedNewsItemLogo.showLabel) ||
      (this.dataInfo && this.dataInfo.label) ||
      ''
    );
  }

  // 方法
  hasFootPrmission(permissionType: number, showPermission: number): boolean {
    return hasFootPrmission(permissionType, showPermission);
  }
}
